import { Camera, Clock, Users, Award, BookMarked, Sparkles } from 'lucide-react';

export default function WhyChooseUs() {
  const reasons = [
    {
      icon: BookMarked,
      title: 'Homework Support',
      description: 'Daily completion of school homework with teacher guidance'
    },
    {
      icon: Award,
      title: 'Concept Clarity',
      description: 'Strong focus on understanding school subjects, not just finishing work'
    },
    {
      icon: Users,
      title: 'Trained Educators',
      description: 'Experienced teachers ensuring proper attention and discipline'
    },
    {
      icon: Camera,
      title: 'Safe Environment',
      description: 'Secure and monitored space for children after school hours'
    },
    {
      icon: Sparkles,
      title: 'Small Batches',
      description: 'Limited students for better focus and personal attention'
    },
    {
      icon: Clock,
      title: 'Flexible Timings',
      description: 'Convenient batches suitable for after school schedules'
    },
  ];

  return (
    <section id="why-us" className="py-16 sm:py-24 bg-pink-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-display text-purple-dark mb-4">
            Why Choose <span className="text-purple-primary">KinderHeaven</span>?
          </h2>
          <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto">
            Complete after-school support with academic focus and skill development
          </p>
        </div>

        {/* Grid of reasons */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 sm:p-8 shadow-soft hover:shadow-lg transition-all duration-300 group"
              >
                <div className="bg-gradient-to-br from-purple-primary/10 to-pink-light/30 w-14 h-14 sm:w-16 sm:h-16 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="text-gray-700" size={28} />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 font-display">
                  {reason.title}
                </h3>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12 sm:mt-16">
          <button className="bg-purple-primary hover:bg-purple-dark text-white px-8 sm:px-10 py-3 sm:py-4 rounded-2xl font-semibold text-base sm:text-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300">
            Discover More Benefits
          </button>
        </div>
      </div>
    </section>
  );
}
